import { useEffect } from 'react';
import { useStudio } from './studio-store';

export function useKeyboardShortcuts(): void {
  const togglePlay = useStudio((s) => s.togglePlay);
  const undo = useStudio((s) => s.undo);
  const redo = useStudio((s) => s.redo);
  const removeClip = useStudio((s) => s.removeClip);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      if (target && ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) return;

      if (event.code === 'Space') {
        event.preventDefault();
        togglePlay();
        return;
      }
      if (event.key === 'Delete' || event.key === 'Backspace') {
        const selected = useStudio.getState().selectedNodeId;
        if (
          selected &&
          useStudio.getState().tracks.some((t) => t.clips.some((c) => c.id === selected))
        ) {
          event.preventDefault();
          removeClip(selected);
        }
        return;
      }
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'z') {
        event.preventDefault();
        if (event.shiftKey) redo();
        else undo();
        return;
      }
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'y') {
        event.preventDefault();
        redo();
        return;
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [togglePlay, undo, redo, removeClip]);
}
